import { createFileRoute } from "@tanstack/react-router";

import { ForceUpdatePanel } from "@/features/search-ops/force-update-panel";

export const Route = createFileRoute("/_authenticated/search/force-update")({
  component: ForceUpdatePanel,
});
